function between(random, min, max) {
  return min + random() * (max - min);
}

export function createAlienLaserBurst(random = Math.random) {
  const count = 1 + Math.floor(random() * 3);
  return Array.from({ length: count }, (_, index) => ({
    left: between(random, 2, 72),
    top: between(random, 5, 92),
    width: between(random, 90, 250),
    angle: between(random, -32, 32),
    delay: index * between(random, 24, 75),
    duration: between(random, 110, 250),
  }));
}

export function randomAlienLaserPause(random = Math.random) {
  return between(random, 650, 3400);
}

export function randomAlienLaserHold(random = Math.random) {
  return between(random, 180, 360);
}
